import { render, staticRenderFns } from "./SuccessTransaction.vue?vue&type=template&id=afc1564e&"
import script from "./SuccessTransaction.vue?vue&type=script&lang=js&"
export * from "./SuccessTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports